import Backbone from 'backbone';
import AppDomain from '../../../home24-shared/core/AppDomain';
import normalizeNLZipCode from '../../../home24-shared/core/normalizers';

export default Backbone.Model.extend({
  defaults: {
    accountType: '',
    showBusinessForm: '',
    gender: '',
    city: '',
    company: '',
    firstname: '',
    lastname: '',
    shippingAddressSimilar: '',
    street: '',
    streetAdd: '',
    telephone: '',
    zip: '',
    email: '',
    password: '',
    password_quality: '',
    accept_agb: '',
    subscribe_to_newsletter: '',
    requireTaxid: ''
  },

  initialize: function() {
    this.bindEvents();
  },

  bindEvents: function() {
    this.on('change:accountType', this.onAccountTypeChange, this);
    this.on('change:requireTaxid', this.onRequireTaxIdChange, this);
    this.on('change:zip', this.fixZipForNL, this);
  },

  onAccountTypeChange: function(model, value) {
    if (value !== 'business') {
      model.set('gender', value);
      model.set('showBusinessForm', false);
    } else {
      model.set('showBusinessForm', true);
    }
  },

  onRequireTaxIdChange: function(model, value) {
    model.set('showTaxId', value === '1');
  },

  fixZipForNL: (model, value) => {
    if (AppDomain.isNL()) {
      model.set('zip', normalizeNLZipCode(value));
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/registerFormModel.js
 **/